import React from 'react';
import TextIconButton from '../basicComponents/TextIconButton';
import { useIcons } from '../../utils/hooks';
import { getText } from '../../utils/functions';

function MobileNavBar({
	sections = [],
	routing = '',
	setRouting = () => {},
	translate,
	colors,
	classNameDIV = 'w-full sticky top-0 md:hidden z-30 h-14 px-4 flex flex-row items-center font-bold justify-between',
	classNameSPAN = 'py-4',
}) {
	/* Icon hook */
	const { ArrowLeftMobile } = useIcons(colors);

	/* Default values for the styles */

	const defaultStyleDIV = {
		backgroundColor: colors?.light,
		color: colors?.text,
		transition: 'all 100ms ease-in',
	};

	const getIndex = value => sections.map(section => section.value).indexOf(value);

	return <div
		id='MobileNavBar'
		className={classNameDIV}
		style={defaultStyleDIV}
	>
		<TextIconButton
			Icon={ArrowLeftMobile}
			classNameBTN={`${getIndex(routing) === 0 ? 'invisible' : ''} focus:outline-none`}
			onClick={() => setRouting(sections[getIndex(routing) - 1].value)} />
		<span
			className={classNameSPAN}
		>
			{getText(sections[getIndex(routing)], translate) ?? routing}
		</span>
		<TextIconButton
			Icon={ArrowLeftMobile}
			classNameBTN={`transform rotate-180 ${getIndex(routing) === (sections.length - 1) ? 'invisible' : ''} focus:outline-none`}
			onClick={() => setRouting(sections[getIndex(routing) + 1].value)} />

	</div>;
}

export default MobileNavBar;
